var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 82,
    viewBox: "0 0 140 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 137,
    height: 79,
    rx: 3.5,
    fill: "#AFDB28",
    fillOpacity: 0.2,
    stroke: "#22A156",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46967 68.4697C8.17678 68.7626 8.17678 69.2374 8.46967 69.5303L13.2426 74.3033C13.5355 74.5962 14.0104 74.5962 14.3033 74.3033C14.5962 74.0104 14.5962 73.5355 14.3033 73.2426L10.0607 69L14.3033 64.7574C14.5962 64.4645 14.5962 63.9896 14.3033 63.6967C14.0104 63.4038 13.5355 63.4038 13.2426 63.6967L8.46967 68.4697ZM131.53 69.5303C131.823 69.2374 131.823 68.7626 131.53 68.4697L126.757 63.6967C126.464 63.4038 125.99 63.4038 125.697 63.6967C125.404 63.9896 125.404 64.4645 125.697 64.7574L129.939 69L125.697 73.2426C125.404 73.5355 125.404 74.0104 125.697 74.3033C125.99 74.5962 126.464 74.5962 126.757 74.3033L131.53 69.5303ZM9 69.75H131V68.25H9V69.75Z",
    fill: "#22A156"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3026 63H61.4901L66.6108 48.4545H69.8636L74.9915 63H72.179L68.294 51.4375H68.1804L64.3026 63ZM64.3949 57.2969H72.0653V59.4134H64.3949V57.2969Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRa);
export default __webpack_public_path__ + "static/media/ra.bb4840e235969cd9f6d0b441e00502bc.svg";
export { ForwardRef as ReactComponent };